import { getCookie } from "../utils/get-cookie";
import Alert from './Alert';
import { handlePhoneCodeChange, populateSelectBox } from './Utils';
import * as Sentry from "@sentry/react";
import FormValidationLogger from "../utils/FormValidationLogger";
class FooterForm {
    constructor() {
        this.form = null;
        this.submitButton = null;
        this.phoneCodesDropdown = null;
        this.phoneInput = null;
        this.phoneCodeInput = null;
    }
    async init() {
        this.submitButton = document.getElementById('js-footer-form-button');
        this.form = document.getElementById('js-footer-form');
        this.phoneCodesDropdown = document.getElementById('js-footer-form-phone-codes');
        this.phoneInput = document.getElementById('js-footer-form-input');
        this.phoneCodeInput = document.getElementById('js-footer-form-phone-code');
        this.form?.addEventListener('submit', this.submitForm.bind(this));
        this.phoneCodesDropdown?.addEventListener('change', this.changePhoneCode.bind(this));
        populateSelectBox(this.phoneCodesDropdown);
        if (this.form) {
            FormValidationLogger.initFormValidationLogging(this.form, "Footer form", {
                pageType: 'footer_form',
                formLocation: 'site_footer'
            });
        }
    }
    changePhoneCode() {
        if (!this.phoneInput || !this.phoneCodesDropdown || !this.phoneCodeInput) {
            return;
        }
        handlePhoneCodeChange(this.phoneInput, this.phoneCodeInput, this.phoneCodesDropdown);
    }
    async submitForm(event) {
        event.preventDefault();
        const data = this.prepareFormData();
        this.submitButton?.classList.add('btn--preloader');
        try {
            const result = await fetch(document.body.getAttribute('data-api-url') ?? '', {
                method: 'POST',
                body: JSON.stringify(data),
                cache: 'default',
            });
            if (result.status === 200) {
                Alert.success('Formulář byl odeslán');
                this.submitButton?.classList.remove('btn--preloader');
                if (this.phoneInput) {
                    this.phoneInput.value = '';
                }
            }
            else {
                this.submitButton?.classList.remove('btn--preloader');
                this.logErrorToSentry(result);
                Alert.error('Chyba odeslání formuláře');
            }
        }
        catch (err) {
            this.submitButton?.classList.remove('btn--preloader');
            this.logErrorToSentry(err);
            Alert.error('Chyba odeslání formuláře');
        }
    }
    logErrorToSentry(error) {
        Sentry.withScope(scope => {
            scope.setLevel('error');
            scope.setTag('error_type', 'form_submission_error');
            scope.setContext('Form Data', {
                phoneNumber: this.phoneInput?.value || 'Unknown',
                phoneCode: this.phoneCodeInput?.value || 'Unknown'
            });
            scope.setContext('Form Context', {
                formLocation: 'site_footer',
                formType: 'contact'
            });
            Sentry.captureException(error);
        });
    }
    prepareFormData() {
        const phone = this.phoneInput?.value ?? "";
        const code = this.phoneCodeInput?.value ?? "";
        const gaCookie = getCookie("_ga");
        const tel1 = `${code}${phone}`;
        return {
            contactSource: 147,
            customFields: {
                // eslint-disable-next-line camelcase
                ...(gaCookie && { Cokie__ga_082f6: gaCookie }),
            },
            topic: "Poptávka z patičky",
            priority: "DEFAULT",
            contactInfo: {
                tel1,
            },
        };
    }
}
export default new FooterForm();
